import { Box, Typography } from '@mui/material'

const AuthInvalid = () => {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
      <Typography color={'primary'}>Token Invalido ou Usuario não Autentificado </Typography>
    </Box>
  )
}

export default AuthInvalid
